/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Draft_BodyInputs */

const en_us2_plan_draft_body = /** @type {(inputs: Plan_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing in your plan changes until you accept it.`)
};

const pt_br2_plan_draft_body = /** @type {(inputs: Plan_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda no seu plano até você aceitar.`)
};

const es_419_plan_draft_body = /** @type {(inputs: Plan_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada cambia en tu plan hasta que lo aceptes.`)
};

const pt_pt2_plan_draft_body = /** @type {(inputs: Plan_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda no teu plano até o aceitares.`)
};

const fr_fr2_plan_draft_body = /** @type {(inputs: Plan_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien ne change dans ton programme tant que tu ne l'acceptes pas.`)
};

const de_de2_plan_draft_body = /** @type {(inputs: Plan_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An deinem Plan ändert sich nichts, bis du ihn übernimmst.`)
};

const it_it2_plan_draft_body = /** @type {(inputs: Plan_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella tua scheda non cambia nulla finché non la accetti.`)
};

/**
* | output |
* | --- |
* | "Nothing in your plan changes until you accept it." |
*
* @param {Plan_Draft_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_draft_body = /** @type {((inputs?: Plan_Draft_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Draft_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_draft_body(inputs)
	if (locale === "es-419") return es_419_plan_draft_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_draft_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_draft_body(inputs)
	if (locale === "de-DE") return de_de2_plan_draft_body(inputs)
	if (locale === "it-IT") return it_it2_plan_draft_body(inputs)
	return en_us2_plan_draft_body(inputs)
});
export { plan_draft_body as "plan.draft_body" }